interface TopObstructionOptions {
  topAlignmentTolerance?: number
}

export function getTopObstructionHeight(
  container: HTMLElement,
  containerRect: DOMRect = container.getBoundingClientRect(),
  options: TopObstructionOptions = {},
): number {
  const stickyElements = Array.from(container.querySelectorAll<HTMLElement>('.sticky'))
  const topAlignmentTolerance = options.topAlignmentTolerance ?? 24

  let overlapObstruction = 0
  let maxStickyHeight = 0

  for (const element of stickyElements) {
    const rect = element.getBoundingClientRect()
    maxStickyHeight = Math.max(maxStickyHeight, rect.height)

    const overlapsTop = rect.bottom > containerRect.top
      && rect.top <= containerRect.top + topAlignmentTolerance

    if (!overlapsTop) {
      continue
    }

    overlapObstruction = Math.max(overlapObstruction, rect.bottom - containerRect.top)
  }

  return Math.max(overlapObstruction, maxStickyHeight)
}
